// extracted by mini-css-extract-plugin
export default {"rating":"Sy-z","numberOfStars":"Ty-z","count":"Uy-z","barGraphSpacing":"Vy-z","barGraph":"Wy-z"};